import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../../../_metronic/helpers'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProvider'

// Extend the interface to include handleReportTab
interface ExtendedListViewContextProps extends ListViewContextProps {
  handleReportTab?: () => void;
}

const ListViewContext = createContext<ExtendedListViewContextProps>(initialListView as ExtendedListViewContextProps)

const TicketProvider: FC<WithChildren & {
  handleAddTab?: (type: 'add' | 'edit') => void,
  openEditTab?: (data: {id: ID, title: string}) => void,
  handleReportTab?: () => void
}> = ({children, handleAddTab, openEditTab, handleReportTab}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false)

  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,

        isDrawerOpen,
        setIsDrawerOpen,

        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
        handleAddTab,
        openEditTab,
        handleReportTab,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {TicketProvider, useListView}